export default {
	CORRECT: 'correct',
	INCORRECT: 'incorrect',
	UNANSWERED: 'unanswered',
	UNSELECTED: 'unselected',
	SELECTED: 'selected',
}
